import { validationTypes, type Validation } from '../../../reducers';
import { isNil } from '../../../utils/answer';
const ValidationReducerAction = Object.freeze({
  ADD_VALIDATION: 'ADD_VALIDATION',
  REMOVE_VALIDATION: 'REMOVE_VALIDATION',
  ADD_VALUE: 'ADD_VALUE'
});
export type ValidationReducerActionTypeT = (typeof ValidationReducerAction)[keyof typeof ValidationReducerAction];
export function validationReducer(state: Array<Validation | undefined | null>, action: {
  type: ValidationReducerActionTypeT;
  kind?: string;
  value?: string;
}): Array<Validation | undefined | null> {
  const {
    type,
    kind,
    value
  } = action;
  switch (type) {
    case 'ADD_VALIDATION':
      {
        if (!state.find(validation => validation && validation.type === value) && value) {
          return [...state, {
            type: validationTypes[value],
            value: ''
          }];
        } else {
          return [...state];
        }
      }
    case 'REMOVE_VALIDATION':
      {
        return state.filter(validation => validation && validation.type !== value);
      }
    case 'ADD_VALUE':
      {
        const validation = state.find(validation => validation && validation.type === kind);
        if (validation && !isNil(value)) {
          // @ts-expect-error todo(ts-migration) TS2322 Type 'string | undefined' is not assignable to type 'string'.
          validation.value = value;
        }
        return [...state];
      }
    default:
      {
        return state;
      }
  }
}